import React, {useEffect, useRef, useState} from 'react';
import {
  Alert,
  Modal,
  ScrollView,
  Text,
  View,
  TouchableOpacity,
  Platform,
  Share,
} from 'react-native';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import Feather from 'react-native-vector-icons/Feather';
import OrdersService from '../../../../services/OrdersService/OrdersService';
import moment, {now} from 'moment';
import RNFS from 'react-native-fs';
import {styles} from './styles';
import {Colors} from '../../../../constants/Colors';
import FileViewer from 'react-native-file-viewer';
import {PDFDocument} from 'pdf-lib';
import QRCode from 'react-native-qrcode-svg';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';
import { downloadFileWeb } from '../../../../utils/downloadFile';

const NFModal = ({visible, onRequestClose, item}) => {
  const [isLoadingNF, setIsLoadingNF] = useState<boolean>(false);
  const [isLoadingBoleto, setIsLoadingBoleto] = useState<boolean>(false);
  const qrCodeRef = useRef();

  const openFileWithDialog = async (filePath: string) => {
    try {
      setTimeout(async () => {
        await FileViewer.open(filePath);
      }, 1000);
    } catch (error: any) {
      console.error('Erro ao abrir o arquivo:', error);
      if (error.message.includes('No app associado com este tipo de mime')) {
        try {
          await FileViewer.open(filePath, {showOpenWithDialog: true});
        } catch (dialogError) {
          console.error('Erro ao abrir o diálogo:', dialogError);
          Alert.alert(
            'Erro',
            'Nenhum aplicativo disponível para abrir este tipo de arquivo.',
          );
        }
      } else {
        Alert.alert('Erro', 'Falha ao abrir o arquivo.');
      }
    }
  };
  const analyticsInstance = getAnalytics();
  const downloadInvoice = async () => {
    try {
      setIsLoadingNF(true);
      const nfKey = item?.Notas?.Nota?.CHAVE_NF;
      if (!nfKey) {
        Alert.alert('Erro', 'Nota fiscal não encontrada');
        return;
      }
      const response = await OrdersService.downloadNF(nfKey);
      const base64data = response.split(',')[1] || response;

      logEvent(analyticsInstance, 'download_invoice', {
        client_code: item?.Status?.CLIENTE,
        order_number: item?.Status?.VBELN,
        invoice_key: nfKey,
      });

      if (Platform.OS === 'web') {
        downloadFileWeb(base64data, `nf_${item?.Status?.VBELN}_${now()}.pdf`);
      } else {
        const directoryPath = Platform.OS === 'android'
          ? RNFS.DownloadDirectoryPath
          : RNFS.DocumentDirectoryPath;
        const path = `${directoryPath}/nf_${item?.Status?.VBELN}_${now()}.pdf`;
        await RNFS.writeFile(path, base64data, 'base64');
        if (Platform.OS === 'ios') {
          await FileViewer.open(path, {showOpenWithDialog: true});
        } else {
          await openFileWithDialog(path);
        }
      }
    } catch (error) {
      console.error(error);
      Alert.alert('Erro', 'Falha ao baixar o PDF');
    } finally {
      setIsLoadingNF(false);
    }
  };
  const downloadBoleto = async () => {
    try {
      setIsLoadingBoleto(true);
      const boletoKey = item?.Notas?.Nota?.CHAVE_NF;
      const pixKey = item?.Notas?.Nota?.PIX_QRCODE;

      if (!boletoKey) {
        Alert.alert('Erro', 'Boleto não encontrado');
        return;
      }

      const response = await OrdersService.downloadBoletos(boletoKey);

      if (!response) {
        Alert.alert('Erro', 'Boleto não encontrado');
        return;
      }

      const base64data = response.split(',')[1] || response;
      const fileName = `boleto_${item?.Status?.VBELN}_${now()}.pdf`;

      logEvent(analyticsInstance, 'download_boleto', {
        client_code: item?.Status?.CLIENTE,
        order_number: item?.Status?.VBELN,
        boleto_key: boletoKey,
      });

      if (Platform.OS === 'web') {
        console.log('[NFModal-OD] pixKey:', pixKey);
        console.log('[NFModal-OD] base64data length:', base64data?.length);
        if (pixKey && typeof pixKey === 'string' && pixKey.trim() !== '') {
          try {
            console.log('[NFModal-OD] Importing qrcode...');
            const QRCodeLib = await import('qrcode');
            console.log('[NFModal-OD] qrcode module:', QRCodeLib);
            console.log('[NFModal-OD] toDataURL type:', typeof QRCodeLib.toDataURL);
            const qrDataUrl: string = await QRCodeLib.toDataURL(pixKey, { width: 280, margin: 1 });
            console.log('[NFModal-OD] QR data URL prefix:', qrDataUrl?.substring(0, 40));
            const pdfBytesArray = Uint8Array.from(atob(base64data), c => c.charCodeAt(0));
            console.log('[NFModal-OD] PDF bytes:', pdfBytesArray.length);
            const pdfDoc = await PDFDocument.load(pdfBytesArray);
            console.log('[NFModal-OD] PDF loaded, pages:', pdfDoc.getPageCount());
            const page = pdfDoc.getPages()[0];
            const qrBase64 = qrDataUrl.split(',')[1];
            const qrImageBytes = Uint8Array.from(atob(qrBase64), c => c.charCodeAt(0));
            const qrImage = await pdfDoc.embedPng(qrImageBytes);
            const { width, height } = qrImage.scale(0.25);
            console.log('[NFModal-OD] QR image size:', width, height, '| page size:', page.getWidth(), page.getHeight());
            page.drawImage(qrImage, {
              x: page.getWidth() - width - 150,
              y: 172,
              width,
              height,
            });
            const pdfModifiedBase64 = await pdfDoc.saveAsBase64();
            console.log('[NFModal-OD] PDF com QR pronto, baixando...');
            downloadFileWeb(pdfModifiedBase64, fileName);
          } catch (qrError) {
            console.error('[NFModal-OD] QR embed falhou, baixando sem QR:', qrError);
            downloadFileWeb(base64data, fileName);
          }
        } else {
          console.log('[NFModal-OD] Sem pixKey, baixando sem QR');
          downloadFileWeb(base64data, fileName);
        }
      } else {
        const directoryPath = Platform.OS === 'android'
          ? RNFS.DownloadDirectoryPath
          : RNFS.DocumentDirectoryPath;
        const pathBoleto = `${directoryPath}/${fileName}`;

        if (pixKey && typeof pixKey === 'string' && pixKey.trim() !== '') {
          const pdfFilePath = `${RNFS.DocumentDirectoryPath}/boleto_temp_${now()}.pdf`;
          const qrCodeFilePath = `${RNFS.DocumentDirectoryPath}/qrcode.png`;
          await RNFS.writeFile(pdfFilePath, base64data, 'base64');
          qrCodeRef.current.toDataURL(async base64Data => {
            await RNFS.writeFile(qrCodeFilePath, base64Data, 'base64');

            const fileBytes = await RNFS.readFile(pdfFilePath, 'base64');
            const pdfDoc = await PDFDocument.load(fileBytes);
            const page = pdfDoc.getPages()[0];

            const qrCodeImageBytes = await RNFS.readFile(qrCodeFilePath, 'base64');
            const qrCodeImage = await pdfDoc.embedPng(qrCodeImageBytes);
            const {width, height} = qrCodeImage.scale(0.13);

            page.drawImage(qrCodeImage, {
              x: page.getWidth() - width - 150,
              y: 172,
              width,
              height,
            });

            const pdfBytes = await pdfDoc.saveAsBase64();
            await RNFS.writeFile(pathBoleto, pdfBytes, 'base64');
          });
        } else {
          await RNFS.writeFile(pathBoleto, base64data, 'base64');
        }

        if (Platform.OS === 'ios') {
          await Share.share({ url: `file://${pathBoleto}` });
        } else {
          await openFileWithDialog(pathBoleto);
        }
      }
    } catch (error) {
      console.error(error);
      Alert.alert('Erro', 'Falha ao baixar o PDF');
    } finally {
      setIsLoadingBoleto(false);
    }
  };
  return (
    <>
      <Modal
        animationType="slide"
        transparent={true}
        visible={visible}
        onRequestClose={onRequestClose}>
        <View style={styles.containerModal}>
          <View style={styles.containerFilter}>
            <TouchableOpacity onPress={onRequestClose}>
              <Feather
                name="x"
                size={32}
                color={Colors.lightGray}
                style={styles.iconX}
              />
            </TouchableOpacity>
            <ScrollView style={styles.containerDrop}>
              <Text style={styles.orderText}>
                Pedido: {item?.['@attributes']?.ORDEM}
              </Text>
              <Text style={styles.codeText}>
                Nota fiscal: {item?.Notas?.Nota?.NFENUM}{' '}
              </Text>
              <Text style={styles.codeText}>
                Data{' '}
                {moment(item?.Notas?.Nota?.DOCDAT, 'YYYY-MM-DD').format(
                  'DD/MM/YYYY',
                )}
              </Text>
              <Text style={styles.codeText}>Status {item?.Status?.STATUS}</Text>
              {(item?.Status?.AUART === 'ZS03' ||
                item?.Status?.AUART === 'ZS11' ||
                item?.Status?.AUART === 'ZS43') &&
                (item?.Notas.length > 0 || item?.Notas?.Nota?.CHAVE_NF) && (
                  <View style={{marginVertical: 30, gap: 20}}>
                    <ButtonComponent
                      title="Baixar Nota Fiscal"
                      onPress={downloadInvoice}
                      isLoading={isLoadingNF}
                      outlined
                    />
                    {item?.Status?.AUART === 'ZS43' && (
                      <>
                        <ButtonComponent
                          title={Platform.OS === 'ios' ? 'Compartilhar Boleto' : 'Baixar Boleto'}
                          onPress={downloadBoleto}
                          isLoading={isLoadingBoleto}
                        />
                        {item?.Notas?.Nota?.PIX_QRCODE&& typeof item?.Notas?.Nota?.PIX_QRCODE === 'string' && item?.Notas?.Nota?.PIX_QRCODE?.trim() !== '' && (
                          <>
                            <View style={{opacity: 0}}>
                              <QRCode
                                value={item?.Notas?.Nota?.PIX_QRCODE}
                                size={200}
                                getRef={c => (qrCodeRef.current = c)}
                              />
                            </View>
                          </>
                        )}
                      </>
                    )}
                  </View>
                )}
            </ScrollView>

            <View style={styles.containerButton}></View>
          </View>
        </View>
        {/* <SortModal
        visible={sort}
        onRequestClose={() => setSort(false)}
        returnOrder={typeOrder => returnSort(typeOrder)}
      /> */}
        {/* {pdfBase64 ? (
          <WebView source={{uri: pdfBase64}} style={{flex: 1}} />
        ) : (
          <Text>Carregando...</Text>
        )} */}
      </Modal>
    </>
  );
};

export default NFModal;
